/* DON'T EDIT THIS FILE: edit original and run build again */ const onboardingTermsOfUseTitle =
  "Solicitud de Apertura de Cuenta - Condiciones Generales";

export default onboardingTermsOfUseTitle;
